<template>
    <form-modal
        :title="lang('Skapa supportärende', 'Create support ticket')"
        :action="route('front.my-pages.api.support.store')"
        :redirect-to="route('front.my-pages.support.index')"
        :primary-button-class="submitButtonClasses"
        method="post"
        name="create-support-ticket"
    >
        <div class="w-full flex flex-col">
            <div class="w-full md:mr-sm">
                <select-input
                    v-model="selectedGroup"
                    :options="groups"
                    name="group"
                    :validations="'required'"
                    :placeholder="lang('Vad kan vi hjälpa till med?', 'How can we help you?')"
                    :required="true"
                />
            </div>
            <div class="w-full md:mr-sm">
                <text-input
                    v-model="subject"
                    :label="lang('Ämne','Subject')"
                    name="subject"
                    :validations="'required|min:1'"
                    :required="true"
                    :disabled="freeze"
                />
            </div>
            <div class="w-full md:mr-sm">
                <textarea-input
                    v-model="description"
                    :label="lang('Beskrivning', 'Description')"
                    name="description"
                    :required="true"
                    :disabled="freeze"
                />
            </div>
            <div class="w-full md:mr-sm" :class="{ 'opacity-50': freeze }">
                <file-input
                    :label="lang('Filer', 'Files')"
                    name="attachments[]"
                    :disabled="freeze"
                />
            </div>
        </div>
    </form-modal>
</template>

<script>
export default {
    props: {
        groups: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selectedGroup: '',
            subject: '',
            description: '',
            loading: false,
            freeze: false,
        };
    },
    computed: {
        submitButtonClasses() {
            let classes = 'is-primary';
            if (this.freeze) {
                classes += ' disabled pointer-events-none';
            }

            return classes;
        },
    },
};
</script>
